/* Firebase for the new pages that need auth (sign-in today; the rebuilt dashboard next).
 *
 *   KTMFirebase.boot()   with the compat SDK scripts already on the page: initialise the app and
 *                        App Check, and set the `auth` / `db` globals google-sign-in-script.js uses.
 *
 * It also keeps localStorage.isSignedIn in sync — the flag the rest of the site writes in
 * config/firebase-init.js and the landing page reads to label its buttons without any SDK.
 */
(function (root) {
  "use strict";

  var CONFIG = {
    apiKey: "AIzaSyAzuLGAupNZ1FWNrwhcjnv6TaJLtBRpGJU",
    authDomain: "krakenthemeta.firebaseapp.com",
    databaseURL: "https://krakenthemeta-default-rtdb.firebaseio.com",
    projectId: "krakenthemeta",
    storageBucket: "krakenthemeta.appspot.com",
    messagingSenderId: "241751198352",
    appId: "1:241751198352:web:72ef61343872fa111fe615",
    measurementId: "G-1EEG4PHXJ0"
  };
  var RECAPTCHA_SITE_KEY = "6LfJITEqAAAAAMuBTYEOHbUgAyIrywxuaO33x7pq";

  root.KTMFirebase = {
    config: CONFIG,

    boot: function () {
      var fb = root.firebase;
      if (!fb.apps.length) fb.initializeApp(CONFIG);
      if (fb.appCheck) fb.appCheck().activate(RECAPTCHA_SITE_KEY, true);
      fb.auth().onAuthStateChanged(function (user) {
        try { localStorage.setItem("isSignedIn", user ? "true" : "false"); } catch (e) { /* storage blocked */ }
      });
      root.auth = fb.auth();
      root.db = fb.firestore();
      return fb;
    }
  };
})(window);
